import { Component, OnInit } from '@angular/core';
import { Observable, merge, of, BehaviorSubject } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { CommonService } from 'src/app/share/services/common.service';
import { AuthService } from 'src/app/share/services/auth.service';

@Component({
  selector: 'app-payroll-timesheets',
  templateUrl: './payroll-timesheets.component.html',
  styleUrls: ['./payroll-timesheets.component.scss']
})
export class PayrollTimesheetsComponent implements OnInit {

  constructor(private commonService: CommonService, private router: Router, private authService: AuthService) { }

  vm$: Observable<IViewModelPayrollTimeSheet>;
  private cmd$ = new BehaviorSubject<IPayrollTimesheetCommand>({ load: true });

  ngOnInit(): void {
    this.loadPage$();
  }

  private loadPage$() {
    this.vm$ = this.cmd$.pipe(
      switchMap(cmd => {
        if (cmd.load) {
          return this.commonService.getData('PageCommand', 'home', 'load-payroll-timesheets-page', { driverCode: this.authService.currentState()?.user?.driverCode }, '/api/ChauffeurPortal').pipe(
            map((v: IViewModelPayrollTimeSheet) => {
              if (v.workingText)
                return { ...v };

              const ret = { ...v, actionsAllowed: false };
              ret.payrollPeriodsVm = undefined;
              ret.lockedTimesheetVm = undefined;
              if (ret.data) {
                ret.payrollPeriodsVm = ret.data.payrollPeriods
              }
              console.log('loadPage timesheets', ret);
              return ret;
            })
          );
        } else {
          return merge(

            // prep
            of(cmd).pipe(
              map(cmd => {

                console.log('cmd', cmd);
                const ret = { ...cmd.viewModel, actionsAllowed: false };

                if (cmd.invokeGetPayrollPeriodTimesheets) {
                  //cmd.viewModel.payrollPeriodsVm.cmdExecutingText = 'Loading...';
                }
                return ret;
              })
            ),

            // invoke API
            of(cmd).pipe(

              // invoke server comand
              switchMap((cmd) => {

                if (cmd.invokeGetPayrollPeriodTimesheets)
                  return this.executeAction$(cmd);
                else
                  throw 'unknown command';
              })
            )
          );
        }
      })
    );
  }

  private executeAction$(cmd: IPayrollTimesheetCommand): Observable<IViewModelPayrollTimeSheet> {
    return this.commonService.getData('PageCommand', 'home', cmd.actionName, { id: cmd.id, driverCode: this.authService.currentState()?.user?.driverCode }, '/api/ChauffeurPortal').pipe(
      map((r: IPayrollTimesheetCommandResult) => {
        if (r.workingText)
          return { ...cmd.viewModel, actionsAllowed: false };

        const ret: IViewModelPayrollTimeSheet = { ...cmd.viewModel, actionsAllowed: true };

        if (cmd.actionName && r.data && r.data.status == 'ok') {
          switch (cmd.actionName) {
            case 'get-locked-timesheets':
              ret.lockedTimesheetVm = undefined;
              if (r.data?.lockedTimesheets) {
                ret.lockedTimesheetVm = [];
                ret.lockedTimesheetVm = r.data?.lockedTimesheets;
              }
              break;
          }
        } else {

        }

        console.log('executeAction$', ret);
        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...cmd.viewModel };

        console.log('error', e);
        ret.lockedTimesheetVm = undefined;

        return of(ret);
      })
    );
  }

  getSelectedValue(id: number, pp: IPayrollPeriod[], vm: IViewModelPayrollTimeSheet) {
    console.log('getSelectedValue', id, pp);
    this.cmd$.next({ invokeGetPayrollPeriodTimesheets: {}, actionName: 'get-locked-timesheets', id: id, viewModel: vm });
  }

  onRowClick(sheedId: number) {
    this.router.navigateByUrl(`/payroll/timesheets/${sheedId}`);
  }
}

/**
 * 
 */
interface IViewModelPayrollTimeSheet extends IPageDataViewModel {
  data?: {
    payrollPeriods: IPayrollPeriod[], lockedTimesheets: ILockedTimesheet[]
  };

  payrollPeriodsVm: IPayrollPeriod[];
  lockedTimesheetVm: ILockedTimesheet[];
}

/**
 * 
 */
interface IPayrollTimesheetCommandResult extends IPageDataViewModel {
  data: { status: string, lockedTimesheets: ILockedTimesheet[] };
}

/**
 * 
 */
interface IPayrollTimesheetCommand {
  load?: boolean;

  actionName?: string;
  id?: number;

  invokeGetPayrollPeriodTimesheets?: {};

  viewModel?: IViewModelPayrollTimeSheet;
}

interface ICommandElement {
  cmdExecutingText?: string;
  cmdExecutedErrorText?: string;
  completedText?: string;
}

interface IPayrollPeriod extends ICommandElement {
  payrollPeriodId?: number;
  startDate?: Date;
  endDate?: Date;
  payrollPeriodLocked?: boolean;
}

interface ILockedTimesheet {
  payrollDate: Date;
  restBreakCount: number;
  mealBreakCount: number;
  mealBreakPenalty: number;
  restBreakPenalty: number;
  isSigned: boolean;
  signedDateTimeUtc: Date;
  payrollPeriodDriverDayId: number;
  payrollPeriodDriverDayTimesheetId: number;
  periodLocked: boolean;
}

